import type { Product, ProductCategory } from "./types";

const stores = ["Emmezeta", "Lesnina XXXL", "Mömax", "JYSK", "Harvey Norman", "IKEA", "Bauhaus", "Pevex"];
const checkedAt = "2026-07-24T09:00:00.000Z";

const names: Record<ProductCategory, string[]> = {
  sofa: ["Mare", "Lina", "Kamen", "Bura", "Nora", "Vela", "Soline", "Luka"],
  "coffee-table": ["Tera", "Oblutak", "Krug", "Molo"],
  rug: ["Lana", "Trag", "Pijesak", "Maslina"],
  "tv-unit": ["Linija", "Uvala", "Riva", "Okvir"],
  lighting: ["Aura", "Disk", "Lumen", "Svit"],
  "garden-set": ["Lavanda", "Brijuni", "Mirta", "Bonaca"],
  fence: ["Ritam", "Verde", "Linea"],
  paver: ["Krš", "Kvarner", "Sivac"],
  "outdoor-light": ["Lanterna", "Prizma"],
};

const basePrice: Record<ProductCategory, number> = {
  sofa: 69900,
  "coffee-table": 15900,
  rug: 9900,
  "tv-unit": 18900,
  lighting: 5900,
  "garden-set": 44900,
  fence: 7900,
  paver: 3200,
  "outdoor-light": 4900,
};

function makeProducts(category: ProductCategory): Product[] {
  return names[category].map((name, index) => ({
    id: `${category}-${index + 1}`,
    demo: true,
    store: stores[(index + Object.keys(names).indexOf(category)) % stores.length],
    title: `${category === "sofa" ? "Sofa" : category === "coffee-table" ? "Stolić" : category === "rug" ? "Tepih" : category === "tv-unit" ? "TV komoda" : category === "lighting" ? "Rasvjeta" : category === "garden-set" ? "Vrtna garnitura" : category === "fence" ? "Ograda" : category === "paver" ? "Opločnik" : "Vanjska svjetiljka"} ${name}`,
    category,
    priceCents: basePrice[category] + index * (category === "paver" ? 350 : 4_700),
    previousPriceCents: index % 3 === 0 ? basePrice[category] + index * 4_700 + 10_000 : undefined,
    currency: "EUR",
    productUrl: `https://example.com/demo/${category}-${index + 1}`,
    imageUrl: `/product-images/${category}.svg`,
    widthCm:
      category === "sofa"
        ? 190 + index * 8
        : category === "coffee-table"
          ? 70 + index * 5
          : category === "rug"
            ? 160 + index * 20
            : category === "tv-unit"
              ? 140 + index * 10
              : undefined,
    depthCm: category === "sofa" ? 88 + index : category === "coffee-table" ? 65 + index * 4 : undefined,
    heightCm: category === "sofa" ? 78 + index : category === "tv-unit" ? 45 + index * 2 : undefined,
    colourTags: index % 3 === 0 ? ["bež", "pijesak"] : index % 3 === 1 ? ["zelena", "maslinasta"] : ["smeđa"],
    styleTags: index % 2 === 0 ? ["mediteranski", "moderan"] : ["skandinavski", "minimalistički"],
    materialTags:
      category === "coffee-table" || category === "paver"
        ? ["kamen"]
        : category === "fence"
          ? ["metal"]
          : ["drvo", "tkanina"],
    featureTags: index % 2 === 0 ? ["prirodni materijali", "kompaktno"] : ["obiteljsko", "lako održavanje"],
    active: true,
    checkedAt,
  }));
}

export const products: Product[] = (Object.keys(names) as ProductCategory[]).flatMap(makeProducts);
